// Vault Error Handler
import Dynatrace from '@/plugins/dynatracePlugin';
import { VaultErrorCodes, type VaultError } from '@ionic-enterprise/identity-vault';
import { useGlobalStore } from '@/stores/global/global.store';
import type { IGlobalError } from '@/stores/global/globalStore.model';
import router from '@/router';
import { RouteNames } from '@/router/routeNames';
import { getAuthClient } from '@/plugins/auth';

export const vaultErrorHandler = async (err: VaultError) => {
  try {
    const globalStore = useGlobalStore();
    // send DT customError and send log to activity_log
    Dynatrace.reportCustomError('PC2_MOBILE_ERR', `[Vault] ${err.code}: ${err.message}`);
    await globalStore.postAuditLog({
      actionId: 'MobileApp_Vault_LoginFailureAction', // optional
      details: `[${Date.now()}] ERROR CODE ${err.code}`, // Additional message stored - optional
      message: err.message, // Error type - optional
    });
    if (window.appConfig.env.valueOf() !== 'prod') {
      const em = {
        error: {
          key: `vaultError ${err.code}: ${err.message}`,
          message: `[Vault] ${err.code}: ${err.message}`,
        },
      };
      // eslint-disable-next-line no-console
      console.error(em);
      globalStore.addError({ ...{ context: 'app' }, ...em } as IGlobalError);
      globalStore.addError({ ...{ context: 'vault' }, ...em } as IGlobalError);
    }
  } catch (_error) {
    /* empty */
  }

  /*
  TODO: implement to use store and implement pub/sub
  so subscribers can implement error handling in their lexical scopes
  */
  const currentRouteIsLoginLandingPage =
    router.currentRoute.value.name === RouteNames.LOGIN_LANDING_PAGE;
  switch (err.code) {
    case VaultErrorCodes.UserCanceledInteraction:
      if (!currentRouteIsLoginLandingPage)
        await router.push({ name: RouteNames.LOGIN_LANDING_PAGE });
      break;
    // handle error code 0: see https://ionic.io/docs/identity-vault/troubleshooting#not-handling-error-code-0
    case VaultErrorCodes.Unknown:
      // handle the Unknown Vault Error by clearing the Vault and routing the app to a login page
      await getAuthClient().clearLocalAuthSession(); // clear the vault
      if (!currentRouteIsLoginLandingPage)
        await router.push({ name: RouteNames.LOGIN_LANDING_PAGE });
      break;
    default:
      if (!currentRouteIsLoginLandingPage)
        await router.push({ name: RouteNames.LOGIN_LANDING_PAGE });
      break;
  }
};
